import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Button, Modal, ModalFooter } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

// Own constants/actions/components
import { add } from 'helpers/accumulator-sum';

const ModalCheck = ({ stateInitial, close, path, itemsCart }) => {
  const history = useHistory();

  const sumTotalPoints = () => {
    const arrayPoints = [];
    itemsCart.map((item) => {
      return arrayPoints.push(Number(item.points) * Number(item.count));
    });
    const sum = arrayPoints.reduce(add, 0);
    return sum.toLocaleString('es-MX');
  };

  return (
    <Modal show={stateInitial} onHide={close} size="md">
      <Modal.Header closeButton>
        <Modal.Title>
          <h3 className="text-tangaroa">Experiencia agregada a tu carrito ¿Deseas continuar con tu pedido?</h3>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-unstyled text-tangaroa">
          {
            /* eslint-disable */
            itemsCart.map((item, index) => (
              <li className="gift-label text-left gift-label mb-3" key={index}>
                <i className="fas fa-star text-matisse mr-2 text-bright-turquoise" />
                <span className="text-bright-turquoise">{item.title}</span>
                {
                  item.type === 'HOUSE' ? (
                    <>
                      <span className="ml-25 d-block py-1">{location ? `En ${item.location}` : ''}</span>
                      <span className="ml-25 d-block py-1">{item.delivery}</span>
                      <span className="ml-25 d-block py-1">{item.menuSelectedName}</span>
                    </>
                  ) : ''
                }
                {
                  item.type === 'MASTERCLASS' || item.type === 'FACE_TO_FACE' ? (
                    <>
                      <span className="ml-25 d-block py-1">{location ? item.location : ''}</span>
                      <span className="ml-25 d-block py-1">{moment(item.startDelivery).format('DD/MM/YYYY')}</span>
                      <span className="ml-25 d-block py-1">{item.menuSelectedName}</span>
                    </>
                  ) : ''
                }
                {
                  item.type === 'TRAVEL_INTERNATIONAL' || item.type === 'TRAVEL' ? (
                    <>
                      <span className="ml-25 d-block py-1">{location ? item.location : ''}</span>
                      <span className="ml-25 d-block py-1">{`Fecha de salida: ${item.startDelivery}`}</span>
                      <span className="ml-25 d-block py-1">{`Fecha de regreso: ${item.endDelivery}`}</span>
                    </>
                  ) : ''
                }
              </li>
            ))
          }
        </ul>
      </Modal.Body>
      <ModalFooter className="m-0">
        <p className="text-tangaroa font-weight-bold mt-0">
          Valor total
        </p>
        <div className="text-primary font-weight-bold ml-4 mt-0">
          { sumTotalPoints() }
          <span className="ml-1">Puntos Aeroméxico Rewards</span>
        </div>
      </ModalFooter>
      <Modal.Footer className="border-top-0">
        <>
          <Button variant="secondary" onClick={close}>
            Continuar navegando
          </Button>
          <Button variant="primary" onClick={() => history.push(`/${path}`)}>
            Ir al carrito
          </Button>
        </>
      </Modal.Footer>
    </Modal>
  );
};

ModalCheck.propTypes = {
  stateInitial: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  path: PropTypes.string.isRequired,
  itemsCart: PropTypes.array.isRequired,
};

export default ModalCheck;
